import { Option } from '@mui/base'
import { type FC } from 'react'
import { useHits, useSortBy } from 'react-instantsearch'
import { useIntl } from 'react-intl'

import { Radio } from 'base-ui'

import { type AlgoliaProxyRecord } from '../../../algolia'
import { useProductSearchContext } from '../../context/productSearchContextValue'
import { ProductSearchRefinement } from '../ProductSearchRefinement'

import { ProductSearchRefinementSortingSelectListbox } from './ProductSearchRefinementSortingSelectListbox'

export const ProductSearchRefinementSortingSelect: FC = () => {
  const intl = useIntl()
  const { productSearchConfig } = useProductSearchContext()

  const { currentRefinement, options, refine } = useSortBy({
    items: productSearchConfig.sortByIndexes,
  })

  const formLabel = intl.formatMessage({ id: 'general.headline.sort' })

  const { results } = useHits<AlgoliaProxyRecord>()

  if (!results?.nbHits || results.nbHits < 1) {
    return null
  }

  return (
    <ProductSearchRefinement
      attribute="sortBy"
      data-qa-id={`form-${formLabel}`}
      onChange={(event, value) => {
        if (value) {
          refine(value)
        }
      }}
      renderValue={() => <span className="truncate">{formLabel}</span>}
      slots={{
        listbox: ProductSearchRefinementSortingSelectListbox,
      }}
      value={currentRefinement}
    >
      {options.map((option) => (
        <Option
          className="flex cursor-pointer items-center gap-2 py-2 pe-4 ps-6"
          data-qa-id={`form-sort-by-${option.label}`}
          key={option.value}
          value={option.value}
        >
          <Radio
            checked={option.value === currentRefinement}
            className="pointer-events-none shrink-0"
            readOnly
          />
          {option.label}
        </Option>
      ))}
    </ProductSearchRefinement>
  )
}
